import React, { useMemo, useState } from 'react';
import { useClients } from '../../contexts/DataContext';
import { Heading } from '../../components/heading';
import { Text } from '../../components/text';
import SearchableListbox from '../../components/SearchableListbox';
import ClientEstadisticas from '../../components/ClientEstadisticas';

// The Estadísticas dashboard over the whole cartera by default (org-wide mode
// of ClientEstadisticas, which adds the "Por cliente" dimension), with an
// optional cliente filter that narrows it to one cliente — the same view the
// ClienteDetails tab shows. One component, one source of truth.
export function EstadisticasCliente({ selectedYear }) {
  const { clientsList } = useClients();
  const [clientId, setClientId] = useState('all');

  const options = useMemo(
    () => [
      { value: 'all', label: 'Todos los clientes' },
      ...[...clientsList]
        .sort((a, b) => (a.nombreEmpresa || '').localeCompare(b.nombreEmpresa || ''))
        .map((c) => ({ value: c.id, label: c.nombreEmpresa || 'Sin nombre' })),
    ],
    [clientsList]
  );

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <Heading level={2} className="text-xl text-azul-surelia">Estadísticas de la cartera</Heading>
          <Text className="text-sm text-azul-surelia/70">Fianzas emitidas en {selectedYear} e historial por año</Text>
        </div>
        <SearchableListbox
          value={clientId}
          onChange={setClientId}
          options={options}
          className="min-w-[260px]"
          placeholder="Todos los clientes"
          searchPlaceholder="Buscar cliente..."
          popupClassName="w-[280px]"
        />
      </div>

      <ClientEstadisticas
        key={clientId}
        clientId={clientId === 'all' ? null : clientId}
        showResumen={false}
        selectedYear={selectedYear}
      />
    </div>
  );
}
